/**
 * Mock Data Configuration
 *
 * Nastavenie pre prepínanie medzi mock a reálnymi dátami
 */

// Hlavný config objekt
const mockConfig = {
  // Globálny prepínač - true = používať mock dáta, false = reálne API
  useMockData: false,

  // Simulácia network latency v ms (0 = okamžitá odpoveď)
  mockDelay: 300,

  // Logging - vypíše do konzoly ktoré API volania sú mockované
  logMockCalls: true,

  // Aktuálna rola používateľa pre mock profil
  currentUserRole: "superadmin",
};

// Načítanie z localStorage ak existuje
if (typeof localStorage !== "undefined") {
  const storedEnabled = localStorage.getItem("useMockData");
  if (storedEnabled !== null) {
    mockConfig.useMockData = storedEnabled === "true";
  }

  const storedDelay = localStorage.getItem("mockDelay");
  if (storedDelay !== null) {
    mockConfig.mockDelay = parseInt(storedDelay, 10);
  }

  const storedRole = localStorage.getItem("mockUserRole");
  if (storedRole !== null) {
    mockConfig.currentUserRole = storedRole;
  }
}

// Globálne sprístupnenie pre runtime konfiguráciu
if (typeof window !== "undefined") {
  window.mockConfig = mockConfig;
}

/**
 * Funkcia na zistenie či je mock režim zapnutý
 */
export const isMockEnabled = () => {
  // Kontrola localStorage
  if (typeof localStorage !== "undefined") {
    const stored = localStorage.getItem("useMockData");
    if (stored !== null) {
      return stored === "true";
    }
  }
  return mockConfig.useMockData;
};

/**
 * Funkcia na nastavenie konfigurácie
 */
export const setMockConfig = (config) => {
  Object.assign(mockConfig, config);
};

/**
 * Pomocná funkcia na zistenie či je entita mockovaná (legacy)
 */
export const isMocked = (entity) => {
  return isMockEnabled();
};

/**
 * Pomocná funkcia na simuláciu delay
 */
export const mockDelay = () => {
  return new Promise((resolve) => setTimeout(resolve, mockConfig.mockDelay));
};

export { mockConfig };
export default mockConfig;
